// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const snover: PokeData = {
  "id": 459,
  "name": "snover",
  "height": 10,
  "weight": 505,
  "base_experience": 67,
  "types": [
    PokeType.GRASS,
    PokeType.ICE
  ],
  "api_moves": [
    "leer",
    "mist",
    "blizzard",
    "razor-leaf",
    "powder-snow",
    "icy-wind",
    "swagger",
    "ingrain",
    "grass-whistle",
    "sheer-cold",
    "energy-ball",
    "ice-shard",
    "wood-hammer",
    "icicle-crash",
    "leafage"
  ],
  "moves": [
    "leer",
    "blizzard",
    "razor-leaf",
    "sheer-cold",
    "energy-ball",
    "ice-shard",
    "wood-hammer",
    "flower-rush",
    "leaf-tornado",
    "aurora-veil",
    "vine-whip",
    "synthesis",
    "frenzy-plant"
  ],
  "evolution_chain": {
    "id": 239,
    "item": null,
    "species": [
      {
        "name": "snover",
        "order": 478,
        "types": [
          PokeType.GRASS,
          PokeType.ICE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "abomasnow",
        "order": 479,
        "types": [
          PokeType.GRASS,
          PokeType.ICE
        ],
        "evolves_from_species_id": 459,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 40,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 57.5,
    "speed": 40,
    "ability_power": 62
  },
  "stat_changes": [],
  "catch_rate": 120,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
